// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__HIrAM","fileDisabled":"File_fileDisabled__2r49Z"};